module.exports = __webpack_public_path__ + "static/contribution_img3_on@2x-a50fcee933f6b01bed4eb19725b612c5.jpg";